import { render } from "./HomePage.vue?vue&type=template&id=06f7f62d&ts=true"
import script from "./HomePage.vue?vue&type=script&lang=ts"
export * from "./HomePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__